var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjectImplementationLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 148,
    height: 148,
    viewBox: "0 0 148 148",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #4eb2a2;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_314_34",
    "data-name": "Component 314 \\u2013 34",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41111",
    "data-name": "Group 41111",
    transform: "translate(-57)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41122",
    "data-name": "Group 41122",
    transform: "translate(10097 8246)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7992",
    "data-name": "Rectangle 7992",
    className: "cls-1",
    width: 148,
    height: 148,
    transform: "translate(-10040 -8246)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41117",
    "data-name": "Group 41117",
    transform: "translate(-10007.589 -8215.659)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42143",
    "data-name": "Path 42143",
    className: "cls-2",
    d: "M71.487,147.3a4.588,4.588,0,1,1-4.588,4.588,4.612,4.612,0,0,1,4.588-4.588",
    transform: "translate(-0.299 -146.115)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42144",
    "data-name": "Path 42144",
    className: "cls-2",
    d: "M28.7,199.8a3.7,3.7,0,1,1-3.7,3.7,3.664,3.664,0,0,1,3.7-3.7",
    transform: "translate(-20.411 -120.915)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42145",
    "data-name": "Path 42145",
    className: "cls-2",
    d: "M49.3,198.5v2.368l-3.7,5.92-3.7-5.92V194.8h7.4Z",
    transform: "translate(-12.299 -123.315)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42146",
    "data-name": "Path 42146",
    className: "cls-2",
    d: "M49.3,181v3.7H41.9V181a4.255,4.255,0,0,1,1.036-2.664A3.567,3.567,0,0,1,45.6,177.3a3.664,3.664,0,0,1,3.7,3.7",
    transform: "translate(-12.299 -131.715)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42147",
    "data-name": "Path 42147",
    className: "cls-2",
    d: "M88.251,166.84v9.176a11.524,11.524,0,0,0-6.364-1.924,11.248,11.248,0,0,0,0,22.5,11.524,11.524,0,0,0,6.364-1.924v9.176c-1.035.3-2.22.592-3.255.888l-1.036,7.4H80.111l-1.184-7.4a19.9,19.9,0,0,1-4-1.036L70.2,209.464,66.94,207.54l2.663-6.956a27.948,27.948,0,0,1-2.96-2.96l-6.956,2.664-1.924-3.256,5.773-4.588a19.68,19.68,0,0,1-1.036-4l-7.4-1.036v-3.848l7.4-1.184a19.68,19.68,0,0,1,1.036-4L57.763,173.8l1.924-3.256,6.956,2.664a27.95,27.95,0,0,1,2.96-2.96l-2.663-6.956,3.256-1.924,4.587,5.772a19.891,19.891,0,0,1,4-1.036l1.183-7.4h3.848l1.036,7.4a22.959,22.959,0,0,1,3.4.74",
    transform: "translate(-5.963 -140.642)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7995",
    "data-name": "Rectangle 7995",
    className: "cls-2",
    width: 21.311,
    height: 14.8,
    transform: "translate(23.977 19.684)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42148",
    "data-name": "Path 42148",
    className: "cls-2",
    d: "M22.5,210.66V154.42a5.785,5.785,0,0,1,5.624-5.92,5.131,5.131,0,0,1,3.848,1.628,5.569,5.569,0,0,1,1.628,4.144V211.4c-.148-3.108-2.516-5.772-5.476-5.772A5.791,5.791,0,0,0,22.5,211.1Z",
    transform: "translate(-21.611 -145.538)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42149",
    "data-name": "Path 42149",
    className: "cls-2",
    d: "M77.032,151.7a1.332,1.332,0,1,1-1.332,1.332,1.331,1.331,0,0,1,1.332-1.332",
    transform: "translate(3.925 -144.003)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42150",
    "data-name": "Path 42150",
    className: "cls-2",
    d: "M73.232,201a1.332,1.332,0,1,1-1.332,1.332A1.331,1.331,0,0,1,73.232,201",
    transform: "translate(2.101 -120.339)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42151",
    "data-name": "Path 42151",
    className: "cls-2",
    d: "M63.232,199.2a1.332,1.332,0,1,1-1.332,1.332,1.331,1.331,0,0,1,1.332-1.332",
    transform: "translate(-2.699 -121.202)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42152",
    "data-name": "Path 42152",
    className: "cls-2",
    d: "M60.132,192.9a1.332,1.332,0,1,1-1.331,1.332,1.332,1.332,0,0,1,1.331-1.332",
    transform: "translate(-4.186 -124.227)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42153",
    "data-name": "Path 42153",
    className: "cls-2",
    d: "M59.532,147.3a1.332,1.332,0,1,1-1.332,1.332,1.331,1.331,0,0,1,1.332-1.332",
    transform: "translate(-4.475 -146.115)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42154",
    "data-name": "Path 42154",
    className: "cls-2",
    d: "M57.032,192.9a1.332,1.332,0,1,1-1.332,1.332,1.331,1.331,0,0,1,1.332-1.332",
    transform: "translate(-5.675 -124.227)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42155",
    "data-name": "Path 42155",
    className: "cls-2",
    d: "M53.832,192.9a1.332,1.332,0,1,1-1.332,1.332,1.332,1.332,0,0,1,1.332-1.332",
    transform: "translate(-7.211 -124.227)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42156",
    "data-name": "Path 42156",
    className: "cls-2",
    d: "M50.732,192.9a1.332,1.332,0,1,1-1.332,1.332,1.331,1.331,0,0,1,1.332-1.332",
    transform: "translate(-8.699 -124.227)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42157",
    "data-name": "Path 42157",
    className: "cls-2",
    d: "M48.832,150.4a1.332,1.332,0,1,1-1.332,1.332,1.332,1.332,0,0,1,1.332-1.332",
    transform: "translate(-9.611 -144.627)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42158",
    "data-name": "Path 42158",
    className: "cls-2",
    d: "M37.032,199.8a1.332,1.332,0,1,1-1.332,1.332,1.332,1.332,0,0,1,1.332-1.332",
    transform: "translate(-15.275 -120.915)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42159",
    "data-name": "Path 42159",
    className: "cls-2",
    d: "M33.832,148.5a1.332,1.332,0,1,1-1.332,1.332,1.332,1.332,0,0,1,1.332-1.332",
    transform: "translate(-16.811 -145.538)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42160",
    "data-name": "Path 42160",
    className: "cls-2",
    d: "M22.788,212.279a.955.955,0,0,1-.888-.888V154.707a6.733,6.733,0,0,1,6.512-6.808A6.493,6.493,0,0,1,33,149.823a6.846,6.846,0,0,1,1.924,4.736v5.328a.888.888,0,1,1-1.776,0v-5.476a4.689,4.689,0,0,0-1.332-3.4,4.591,4.591,0,0,0-3.256-1.332,4.816,4.816,0,0,0-4.588,5.032v56.684c-.3.444-.74.888-1.184.888",
    transform: "translate(-21.899 -145.827)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42161",
    "data-name": "Path 42161",
    className: "cls-2",
    d: "M34.688,207.2a.955.955,0,0,1-.888-.888V156.287a.888.888,0,0,1,1.776,0v50.024a.955.955,0,0,1-.888.888",
    transform: "translate(-16.187 -142.227)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42162",
    "data-name": "Path 42162",
    className: "cls-2",
    d: "M77.136,192.771a12.136,12.136,0,0,1,0-24.272,11.944,11.944,0,0,1,6.809,2.072.965.965,0,0,1-1.037,1.628,10.353,10.353,0,1,0-5.772,18.944,9.867,9.867,0,0,0,5.772-1.776.965.965,0,0,1,1.037,1.628,14.537,14.537,0,0,1-6.809,1.776",
    transform: "translate(-1.211 -135.939)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42163",
    "data-name": "Path 42163",
    className: "cls-2",
    d: "M84.051,213.255H80.2a.828.828,0,0,1-.887-.74l-1.036-6.66a21.587,21.587,0,0,1-2.96-.74l-4.293,5.328a1.151,1.151,0,0,1-1.184.3l-3.256-1.924a.993.993,0,0,1-.444-1.184l2.517-6.364a13.792,13.792,0,0,1-2.073-2.072l-6.364,2.516a.99.99,0,0,1-1.183-.444l-1.924-3.256a.8.8,0,0,1,.295-1.184l5.329-4.292a17.04,17.04,0,0,1-.74-2.96l-6.66-1.036a.829.829,0,0,1-.74-.888V183.8a.829.829,0,0,1,.74-.888L62,181.879a21.215,21.215,0,0,1,.74-2.96l-5.329-4.292a1.15,1.15,0,0,1-.295-1.184l1.924-3.256a.99.99,0,0,1,1.183-.444l6.364,2.516a13.794,13.794,0,0,1,2.073-2.072l-2.369-6.364a.991.991,0,0,1,.445-1.184l3.255-1.924a.8.8,0,0,1,1.185.3l4.291,5.328a17.344,17.344,0,0,1,2.96-.74l1.036-6.66a.829.829,0,0,1,.888-.74H84.2a.828.828,0,0,1,.887.74l1.036,6.66a19.783,19.783,0,0,1,2.813.74.936.936,0,0,1-.593,1.776,23.694,23.694,0,0,0-3.107-.74.792.792,0,0,1-.74-.74l-1.185-6.808h-2.22l-1.035,6.66a.794.794,0,0,1-.74.74,18.586,18.586,0,0,0-3.849,1.036.915.915,0,0,1-1.036-.3l-4.144-5.18-2.071,1.036,2.515,6.216a.915.915,0,0,1-.295,1.036,25.24,25.24,0,0,0-2.813,2.812.915.915,0,0,1-1.036.3l-6.216-2.516-1.184,1.924,5.18,4.144a.981.981,0,0,1,.3,1.036,16.525,16.525,0,0,0-1.036,3.848.793.793,0,0,1-.74.74l-6.511,1.184v2.22l6.66,1.036a.793.793,0,0,1,.74.74,18.473,18.473,0,0,0,1.035,3.848.915.915,0,0,1-.295,1.036l-5.18,4.144,1.184,1.924,6.216-2.516a.912.912,0,0,1,1.035.3,25.348,25.348,0,0,0,2.812,2.812.982.982,0,0,1,.3,1.036l-2.517,6.216,1.924,1.184,4.144-5.18a.981.981,0,0,1,1.036-.3,16.374,16.374,0,0,0,3.849,1.036.793.793,0,0,1,.74.74l1.035,6.66h2.22l1.036-6.66a.793.793,0,0,1,.74-.74,23.682,23.682,0,0,0,3.109-.74.936.936,0,1,1,.591,1.776,19.7,19.7,0,0,1-2.811.74l-1.036,6.66a.96.96,0,0,1-.889.74",
    transform: "translate(-6.203 -140.883)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42164",
    "data-name": "Path 42164",
    className: "cls-2",
    d: "M104.187,218.3H58.9a.888.888,0,0,1,0-1.776h44.4V157.471H34.776v50.616a.889.889,0,0,1-1.777,0c-.148-2.664-2.22-4.884-4.588-4.884a4.706,4.706,0,0,0-4.587,4.588c.147,5.032,3.552,8.584,8.287,8.584H51.5a.888.888,0,0,1,0,1.776H31.964a9.406,9.406,0,0,1-7.253-3.108,10.948,10.948,0,0,1-2.812-7.4V207.5a6.613,6.613,0,0,1,6.512-6.216A6.214,6.214,0,0,1,33,203.5V156.287a.956.956,0,0,1,.888-.888h70.3a.955.955,0,0,1,.889.888v60.976a.99.99,0,0,1-.889,1.036",
    transform: "translate(-21.899 -142.227)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42165",
    "data-name": "Path 42165",
    className: "cls-2",
    d: "M59.7,175.775H38.388a.954.954,0,0,1-.888-.888v-14.8a.954.954,0,0,1,.888-.887H59.7a.954.954,0,0,1,.888.887v14.8a.954.954,0,0,1-.888.888m-20.424-1.923H58.664V160.828H39.276Z",
    transform: "translate(-14.411 -140.402)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42166",
    "data-name": "Path 42166",
    className: "cls-2",
    d: "M54.8,163.475H40.888a.888.888,0,1,1,0-1.776H54.8a.888.888,0,1,1,0,1.776",
    transform: "translate(-13.211 -139.203)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42167",
    "data-name": "Path 42167",
    className: "cls-2",
    d: "M54.8,165.975H40.888a.888.888,0,1,1,0-1.776H54.8a.888.888,0,1,1,0,1.776",
    transform: "translate(-13.211 -138.003)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42168",
    "data-name": "Path 42168",
    className: "cls-2",
    d: "M54.8,168.475H40.888a.888.888,0,1,1,0-1.776H54.8a.888.888,0,1,1,0,1.776",
    transform: "translate(-13.211 -136.803)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42169",
    "data-name": "Path 42169",
    className: "cls-2",
    d: "M45.888,216.364a.814.814,0,0,1-.74-.444l-3.7-5.92a.544.544,0,0,1-.148-.444V181.288a4.588,4.588,0,1,1,9.176,0V209.7a.544.544,0,0,1-.148.444l-3.7,5.92a1.131,1.131,0,0,1-.74.3m-2.812-7.1,2.812,4.44,2.812-4.44V181.14a2.829,2.829,0,0,0-4.736-2.072,2.451,2.451,0,0,0-.74,1.924V209.26Z",
    transform: "translate(-12.587 -132.002)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42170",
    "data-name": "Path 42170",
    className: "cls-2",
    d: "M49.588,183.475h-7.4a.888.888,0,1,1,0-1.776h7.4a.888.888,0,1,1,0,1.776",
    transform: "translate(-12.587 -129.603)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42172",
    "data-name": "Path 42172",
    className: "cls-2",
    d: "M49.588,195.975h-7.4a.888.888,0,1,1,0-1.776h7.4a.888.888,0,1,1,0,1.776",
    transform: "translate(-12.587 -123.603)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42173",
    "data-name": "Path 42173",
    className: "cls-2",
    d: "M68.424,204.076H41.488a.888.888,0,0,1,0-1.776H68.276a.955.955,0,0,1,.888.888.741.741,0,0,1-.74.888",
    transform: "translate(-12.923 -119.714)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42174",
    "data-name": "Path 42174",
    className: "cls-2",
    d: "M28.988,208.375a4.588,4.588,0,1,1,4.588-4.588,4.611,4.611,0,0,1-4.588,4.588m0-7.4a2.81,2.81,0,0,0-2.812,2.812,2.812,2.812,0,1,0,5.624,0,2.81,2.81,0,0,0-2.812-2.812",
    transform: "translate(-20.699 -121.203)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42175",
    "data-name": "Path 42175",
    className: "cls-2",
    d: "M71.823,157.747a5.624,5.624,0,1,1,5.625-5.624,5.621,5.621,0,0,1-5.625,5.624m0-9.176a3.7,3.7,0,1,0,3.7,3.7,3.665,3.665,0,0,0-3.7-3.7",
    transform: "translate(-0.635 -146.499)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41119",
    "data-name": "Group 41119",
    transform: "translate(0.889 1.184)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7998",
    "data-name": "Rectangle 7998",
    className: "cls-3",
    width: 21.311,
    height: 14.8,
    transform: "translate(23.087 18.5)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41120",
    "data-name": "Group 41120"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42177",
    "data-name": "Path 42177",
    className: "cls-3",
    d: "M71.487,147.3a4.588,4.588,0,1,1-4.588,4.588,4.612,4.612,0,0,1,4.588-4.588",
    transform: "translate(-1.188 -147.299)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42178",
    "data-name": "Path 42178",
    className: "cls-3",
    d: "M28.7,199.8a3.7,3.7,0,1,1-3.7,3.7,3.664,3.664,0,0,1,3.7-3.7",
    transform: "translate(-21.3 -122.099)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42179",
    "data-name": "Path 42179",
    className: "cls-3",
    d: "M49.3,198.5v2.368l-3.7,5.92-3.7-5.92V194.8h7.4Z",
    transform: "translate(-13.188 -124.499)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42180",
    "data-name": "Path 42180",
    className: "cls-3",
    d: "M49.3,181v3.7H41.9V181a4.255,4.255,0,0,1,1.036-2.664A3.567,3.567,0,0,1,45.6,177.3a3.664,3.664,0,0,1,3.7,3.7",
    transform: "translate(-13.188 -132.899)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42181",
    "data-name": "Path 42181",
    className: "cls-3",
    d: "M88.251,166.84v9.176a11.524,11.524,0,0,0-6.364-1.924,11.248,11.248,0,0,0,0,22.5,11.524,11.524,0,0,0,6.364-1.924v9.176c-1.035.3-2.22.592-3.255.888l-1.036,7.4H80.111l-1.184-7.4a19.9,19.9,0,0,1-4-1.036L70.2,209.464,66.94,207.54l2.663-6.956a27.948,27.948,0,0,1-2.96-2.96l-6.956,2.664-1.924-3.256,5.773-4.588a19.68,19.68,0,0,1-1.036-4l-7.4-1.036v-3.848l7.4-1.184a19.68,19.68,0,0,1,1.036-4L57.763,173.8l1.924-3.256,6.956,2.664a27.95,27.95,0,0,1,2.96-2.96l-2.663-6.956,3.256-1.924,4.587,5.772a19.891,19.891,0,0,1,4-1.036l1.183-7.4h3.848l1.036,7.4a22.959,22.959,0,0,1,3.4.74",
    transform: "translate(-6.852 -141.826)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42182",
    "data-name": "Path 42182",
    className: "cls-3",
    d: "M22.5,210.66V154.42a5.785,5.785,0,0,1,5.624-5.92,5.131,5.131,0,0,1,3.848,1.628,5.569,5.569,0,0,1,1.628,4.144V211.4c-.148-3.108-2.516-5.772-5.476-5.772A5.791,5.791,0,0,0,22.5,211.1Z",
    transform: "translate(-22.5 -146.723)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_42183",
    "data-name": "Path 42183",
    className: "cls-2",
    d: "M77.032,151.7a1.332,1.332,0,1,1-1.332,1.332,1.331,1.331,0,0,1,1.332-1.332",
    transform: "translate(3.925 -144.003)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42184",
    "data-name": "Path 42184",
    className: "cls-2",
    d: "M73.232,201a1.332,1.332,0,1,1-1.332,1.332A1.331,1.331,0,0,1,73.232,201",
    transform: "translate(2.101 -120.339)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42185",
    "data-name": "Path 42185",
    className: "cls-2",
    d: "M63.232,199.2a1.332,1.332,0,1,1-1.332,1.332,1.331,1.331,0,0,1,1.332-1.332",
    transform: "translate(-2.699 -121.202)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42186",
    "data-name": "Path 42186",
    className: "cls-2",
    d: "M60.132,192.9a1.332,1.332,0,1,1-1.331,1.332,1.332,1.332,0,0,1,1.331-1.332",
    transform: "translate(-4.186 -124.227)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42187",
    "data-name": "Path 42187",
    className: "cls-2",
    d: "M59.532,147.3a1.332,1.332,0,1,1-1.332,1.332,1.331,1.331,0,0,1,1.332-1.332",
    transform: "translate(-4.475 -146.115)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42188",
    "data-name": "Path 42188",
    className: "cls-2",
    d: "M57.032,192.9a1.332,1.332,0,1,1-1.332,1.332,1.331,1.331,0,0,1,1.332-1.332",
    transform: "translate(-5.675 -124.227)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42189",
    "data-name": "Path 42189",
    className: "cls-2",
    d: "M53.832,192.9a1.332,1.332,0,1,1-1.332,1.332,1.332,1.332,0,0,1,1.332-1.332",
    transform: "translate(-7.211 -124.227)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42190",
    "data-name": "Path 42190",
    className: "cls-2",
    d: "M50.732,192.9a1.332,1.332,0,1,1-1.332,1.332,1.331,1.331,0,0,1,1.332-1.332",
    transform: "translate(-8.699 -124.227)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42191",
    "data-name": "Path 42191",
    className: "cls-2",
    d: "M48.832,150.4a1.332,1.332,0,1,1-1.332,1.332,1.332,1.332,0,0,1,1.332-1.332",
    transform: "translate(-9.611 -144.627)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42192",
    "data-name": "Path 42192",
    className: "cls-2",
    d: "M37.032,199.8a1.332,1.332,0,1,1-1.332,1.332,1.332,1.332,0,0,1,1.332-1.332",
    transform: "translate(-15.275 -120.915)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42193",
    "data-name": "Path 42193",
    className: "cls-2",
    d: "M33.832,148.5a1.332,1.332,0,1,1-1.332,1.332,1.332,1.332,0,0,1,1.332-1.332",
    transform: "translate(-16.811 -145.538)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42194",
    "data-name": "Path 42194",
    className: "cls-2",
    d: "M22.788,212.279a.955.955,0,0,1-.888-.888V154.707a6.733,6.733,0,0,1,6.512-6.808A6.493,6.493,0,0,1,33,149.823a6.846,6.846,0,0,1,1.924,4.736v5.328a.888.888,0,1,1-1.776,0v-5.476a4.689,4.689,0,0,0-1.332-3.4,4.591,4.591,0,0,0-3.256-1.332,4.816,4.816,0,0,0-4.588,5.032v56.684c-.3.444-.74.888-1.184.888",
    transform: "translate(-21.899 -145.827)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42195",
    "data-name": "Path 42195",
    className: "cls-2",
    d: "M34.688,207.2a.955.955,0,0,1-.888-.888V156.287a.888.888,0,0,1,1.776,0v50.024a.955.955,0,0,1-.888.888",
    transform: "translate(-16.187 -142.227)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42196",
    "data-name": "Path 42196",
    className: "cls-2",
    d: "M77.136,192.771a12.136,12.136,0,0,1,0-24.272,11.944,11.944,0,0,1,6.809,2.072.965.965,0,0,1-1.037,1.628,10.353,10.353,0,1,0-5.772,18.944,9.867,9.867,0,0,0,5.772-1.776.965.965,0,0,1,1.037,1.628,14.537,14.537,0,0,1-6.809,1.776",
    transform: "translate(-1.211 -135.939)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42197",
    "data-name": "Path 42197",
    className: "cls-2",
    d: "M84.051,213.255H80.2a.828.828,0,0,1-.887-.74l-1.036-6.66a21.587,21.587,0,0,1-2.96-.74l-4.293,5.328a1.151,1.151,0,0,1-1.184.3l-3.256-1.924a.993.993,0,0,1-.444-1.184l2.517-6.364a13.792,13.792,0,0,1-2.073-2.072l-6.364,2.516a.99.99,0,0,1-1.183-.444l-1.924-3.256a.8.8,0,0,1,.295-1.184l5.329-4.292a17.04,17.04,0,0,1-.74-2.96l-6.66-1.036a.829.829,0,0,1-.74-.888V183.8a.829.829,0,0,1,.74-.888L62,181.879a21.215,21.215,0,0,1,.74-2.96l-5.329-4.292a1.15,1.15,0,0,1-.295-1.184l1.924-3.256a.99.99,0,0,1,1.183-.444l6.364,2.516a13.794,13.794,0,0,1,2.073-2.072l-2.369-6.364a.991.991,0,0,1,.445-1.184l3.255-1.924a.8.8,0,0,1,1.185.3l4.291,5.328a17.344,17.344,0,0,1,2.96-.74l1.036-6.66a.829.829,0,0,1,.888-.74H84.2a.828.828,0,0,1,.887.74l1.036,6.66a19.783,19.783,0,0,1,2.813.74.936.936,0,0,1-.593,1.776,23.694,23.694,0,0,0-3.107-.74.792.792,0,0,1-.74-.74l-1.185-6.808h-2.22l-1.035,6.66a.794.794,0,0,1-.74.74,18.586,18.586,0,0,0-3.849,1.036.915.915,0,0,1-1.036-.3l-4.144-5.18-2.071,1.036,2.515,6.216a.915.915,0,0,1-.295,1.036,25.24,25.24,0,0,0-2.813,2.812.915.915,0,0,1-1.036.3l-6.216-2.516-1.184,1.924,5.18,4.144a.981.981,0,0,1,.3,1.036,16.525,16.525,0,0,0-1.036,3.848.793.793,0,0,1-.74.74l-6.511,1.184v2.22l6.66,1.036a.793.793,0,0,1,.74.74,18.473,18.473,0,0,0,1.035,3.848.915.915,0,0,1-.295,1.036l-5.18,4.144,1.184,1.924,6.216-2.516a.912.912,0,0,1,1.035.3,25.348,25.348,0,0,0,2.812,2.812.982.982,0,0,1,.3,1.036l-2.517,6.216,1.924,1.184,4.144-5.18a.981.981,0,0,1,1.036-.3,16.374,16.374,0,0,0,3.849,1.036.793.793,0,0,1,.74.74l1.035,6.66h2.22l1.036-6.66a.793.793,0,0,1,.74-.74,23.682,23.682,0,0,0,3.109-.74.936.936,0,1,1,.591,1.776,19.7,19.7,0,0,1-2.811.74l-1.036,6.66a.96.96,0,0,1-.889.74",
    transform: "translate(-6.203 -140.883)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42198",
    "data-name": "Path 42198",
    className: "cls-2",
    d: "M104.187,218.3H58.9a.888.888,0,0,1,0-1.776h44.4V157.471H34.776v50.616a.889.889,0,0,1-1.777,0c-.148-2.664-2.22-4.884-4.588-4.884a4.706,4.706,0,0,0-4.587,4.588c.147,5.032,3.552,8.584,8.287,8.584H51.5a.888.888,0,0,1,0,1.776H31.964a9.406,9.406,0,0,1-7.253-3.108,10.948,10.948,0,0,1-2.812-7.4V207.5a6.613,6.613,0,0,1,6.512-6.216A6.214,6.214,0,0,1,33,203.5V156.287a.956.956,0,0,1,.888-.888h70.3a.955.955,0,0,1,.889.888v60.976a.99.99,0,0,1-.889,1.036",
    transform: "translate(-21.899 -142.227)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42199",
    "data-name": "Path 42199",
    className: "cls-2",
    d: "M59.7,175.775H38.388a.954.954,0,0,1-.888-.888v-14.8a.954.954,0,0,1,.888-.887H59.7a.954.954,0,0,1,.888.887v14.8a.954.954,0,0,1-.888.888m-20.424-1.923H58.664V160.828H39.276Z",
    transform: "translate(-14.411 -140.402)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42200",
    "data-name": "Path 42200",
    className: "cls-2",
    d: "M54.8,163.475H40.888a.888.888,0,1,1,0-1.776H54.8a.888.888,0,1,1,0,1.776",
    transform: "translate(-13.211 -139.203)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42201",
    "data-name": "Path 42201",
    className: "cls-2",
    d: "M54.8,165.975H40.888a.888.888,0,1,1,0-1.776H54.8a.888.888,0,1,1,0,1.776",
    transform: "translate(-13.211 -138.003)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42202",
    "data-name": "Path 42202",
    className: "cls-2",
    d: "M54.8,168.475H40.888a.888.888,0,1,1,0-1.776H54.8a.888.888,0,1,1,0,1.776",
    transform: "translate(-13.211 -136.803)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42203",
    "data-name": "Path 42203",
    className: "cls-2",
    d: "M45.888,216.364a.814.814,0,0,1-.74-.444l-3.7-5.92a.544.544,0,0,1-.148-.444V181.288a4.588,4.588,0,1,1,9.176,0V209.7a.544.544,0,0,1-.148.444l-3.7,5.92a1.131,1.131,0,0,1-.74.3m-2.812-7.1,2.812,4.44,2.812-4.44V181.14a2.829,2.829,0,0,0-4.736-2.072,2.451,2.451,0,0,0-.74,1.924V209.26Z",
    transform: "translate(-12.587 -132.002)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42204",
    "data-name": "Path 42204",
    className: "cls-2",
    d: "M49.588,183.475h-7.4a.888.888,0,1,1,0-1.776h7.4a.888.888,0,1,1,0,1.776",
    transform: "translate(-12.587 -129.603)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42206",
    "data-name": "Path 42206",
    className: "cls-2",
    d: "M49.588,195.975h-7.4a.888.888,0,1,1,0-1.776h7.4a.888.888,0,1,1,0,1.776",
    transform: "translate(-12.587 -123.603)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42207",
    "data-name": "Path 42207",
    className: "cls-2",
    d: "M68.424,204.076H41.488a.888.888,0,0,1,0-1.776H68.276a.955.955,0,0,1,.888.888.741.741,0,0,1-.74.888",
    transform: "translate(-12.923 -119.714)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42208",
    "data-name": "Path 42208",
    className: "cls-2",
    d: "M28.988,208.375a4.588,4.588,0,1,1,4.588-4.588,4.611,4.611,0,0,1-4.588,4.588m0-7.4a2.81,2.81,0,0,0-2.812,2.812,2.812,2.812,0,1,0,5.624,0,2.81,2.81,0,0,0-2.812-2.812",
    transform: "translate(-20.699 -121.203)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42209",
    "data-name": "Path 42209",
    className: "cls-2",
    d: "M71.823,157.747a5.624,5.624,0,1,1,5.625-5.624,5.621,5.621,0,0,1-5.625,5.624m0-9.176a3.7,3.7,0,1,0,3.7,3.7,3.665,3.665,0,0,0-3.7-3.7",
    transform: "translate(-0.635 -146.499)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectImplementationLight);
export default __webpack_public_path__ + "static/media/project_implementation_light.d0de9dd504160169f4a4d1d7e654f942.svg";
export { ForwardRef as ReactComponent };